import { track } from '@tldraw/tldraw'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ColorsPanel } from './ColorsPanel'
import { StylePropObserver } from './StylePropObserver'
import { SelectionObserver } from './SelectionObserver'

export const ColorsPanelContainer = track(
  observer(() => {
    const { designStore } = useRootStore()
    const panel = designStore?.panel

    if (panel?.type !== 'colors') return null

    const { type, styleProp, onSelectionChange, ...props } = panel

    return (
      <>
        {styleProp && <StylePropObserver styleProp={styleProp} />}
        {onSelectionChange && <SelectionObserver />}
        <ColorsPanel {...props} />
      </>
    )
  }),
)
